import { z } from 'zod';

/**
 * Query-string boolean. Use this, never `z.coerce.boolean()`: coercion is
 * `Boolean(value)`, so the string `'false'` parses as `true`.
 *
 * Accepts real booleans and the strings `'true'` / `'1'` (→ `true`) and
 * `'false'` / `'0'` (→ `false`); anything else is a Zod `invalid_type` issue.
 * Chain `.optional()` / `.default(...)` as usual.
 */
export function queryBoolean() {
  return z.preprocess((value) => {
    if (value === 'true' || value === '1') return true;
    if (value === 'false' || value === '0') return false;
    return value;
  }, z.boolean());
}
